import { createAsyncThunk } from '@reduxjs/toolkit';
import InvoiceAPI from './services';

export const fetch = createAsyncThunk('invoice/fetchAll', async (params, { rejectWithValue }) => {
  try {
    const response = await InvoiceAPI.fetchAll(params);

    return response.data;
  } catch (err) {
    return rejectWithValue(err.response?.data);
  }
});

/* What the client already has waiting, used to decide whether a new order tips
   the batch past the point where a delivery date is asked for. */
export const fetchPendingSummary = createAsyncThunk(
  'invoice/fetchPendingSummary',
  async (_arg, { rejectWithValue }) => {
    try {
      const response = await InvoiceAPI.fetchPendingSummary();

      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data);
    }
  },
);
